import { useForm } from 'components/form/Form';
import { classNames } from 'libs/react';
import { useIdent } from 'libs/react';
import { useIf } from 'libs/react';
import { useQuery } from 'libs/react';
import { useState } from 'libs/react';
import { useWatch } from 'libs/react';
import { MediaPicker } from '../MediaPicker';
import { FormFieldError } from 'components/form/FormFieldError';
import { FormFieldInfos } from 'components/form/FormFieldInfos';
import { FormFieldLabel } from 'components/form/FormFieldLabel';
import { Fragment } from 'libs/react';
import { React } from 'libs/react';
import { MediaCustomPicker } from '../MediaCustomPicker';
import { SelectorMediasQuery } from './FormMediaSelector';
import './FormMediaPicker.scss';
import { FormInput } from 'components/form/FormInput';
/**
 * @component FormMediaPicker
 * @since 1.0.0
 */
export function FormMediaPicker(props) {
    let { name, customMedia, editable, square, size, style, title, infos, label, multiple, error, types, disabled, required, restricted, useLink, onItemClick, primaryImageId, hasVisibilitySelection, visibilityValues, hasLanguageSelection, languageValues, languageOptions, fromPublic } = Object.assign({ size: 'medium', style: 'normal' }, props);
    const form = useForm();
    const [ident] = useIdent('form-media-picker');
    const [focused, setFocused] = useState(false);
    const [value, setValue] = useState(props.value || null);
    const [data] = useQuery(SelectorMediasQuery, {
        skip: value == null,
        variables: {
            selectedInput: {
                query: {
                    field: 'ids',
                    value: value,
                    operator: 'IN'
                }
            },
            input: {
                query: {
                    field: 'ids',
                    value: Array.isArray(value) ? value.join() : value,
                    operator: 'IN'
                },
                restricted: restricted || undefined
            }
        }
    });
    /**
     * @function onMediaPickerPick
     * @since 1.0.0
     * @hidden
     */
    function onMediaPickerPick(media) {
        var _a;
        if (disabled) {
            return;
        }
        props.onMediaPickerPick && props.onMediaPickerPick(media);
        if (Array.isArray(media)) {
            setValue(media.map((m) => m.id));
        }
        else {
            setValue((_a = media === null || media === void 0 ? void 0 : media.id) !== null && _a !== void 0 ? _a : null);
        }
    }
    useIf(focused, props.onFocus, props.onBlur);
    useWatch(() => {
        if (props.onChange) {
            //props.onChange(value);
        }
    }, [value]);
    const media = Array.isArray(data === null || data === void 0 ? void 0 : data.medias) ? data === null || data === void 0 ? void 0 : data.medias[0] : data === null || data === void 0 ? void 0 : data.medias;
    if (error == null) {
        error = form.getError(name);
    }
    const className = classNames('form-media-picker', 'form-media-picker--' + style, { 'form-media-picker--is-required': required }, { 'form-media-picker--is-disabled': disabled }, { 'form-media-picker--is-focused': focused }, { 'form-media-picker--has-label': label }, { 'form-media-picker--has-value': value }, { 'form-media-picker--has-media': media }, { 'form-media-picker--has-error': error }, props.className);
    return (React.createElement(Fragment, null,
        React.createElement("div", { className: className },
            React.createElement("div", { className: "form-media-picker-field" },
                React.createElement("div", { className: "form-media-picker-field-head" },
                    React.createElement(FormFieldLabel, { className: "form-media-picker-label", style: style, label: label, ident: ident, required: required, disabled: disabled }),
                    React.createElement(FormFieldInfos, { className: "form-media-picker-infos", style: style, infos: infos }),
                    React.createElement(FormInput, { type: "hidden", name: name, value: value, required: required })),
                React.createElement("div", { className: "form-media-picker-field-body" }, customMedia && square ? (React.createElement(MediaCustomPicker, { editable: editable, size: size, style: style, title: title, types: types, medias: data === null || data === void 0 ? void 0 : data.selectedMedias, onPick: onMediaPickerPick, onItemClick: onItemClick, useLink: useLink, multiple: multiple, primaryImageId: primaryImageId, hasVisibilitySelection: hasVisibilitySelection, visibilityValues: visibilityValues, hasLanguageSelection: hasLanguageSelection, languageValues: languageValues, languageOptions: languageOptions })) : (React.createElement(MediaPicker, { editable: editable, size: size, style: style, title: title, types: types, medias: data === null || data === void 0 ? void 0 : data.medias, onPick: onMediaPickerPick, useLink: useLink, multiple: multiple, fromPublic: fromPublic }))))),
        React.createElement(FormFieldError, { error: error })));
}
